import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    atmDescription: 'The withdrawal limit affects all ATM withdrawals',
    atmFormTitle: 'Withdrawals (over 30 rolling days)',
    atmLabel: 'Current withdrawal limit',
    atmLimitUpdated: 'The new withdrawal limit has been saved!',
    atmTitle: 'Change withdrawal limit',
    cta: 'Save',
    errorMessage: 'Oops! There was an unknown error.',
    errors: {
      overLimit: 'The amount entered cannot exceed €{limit}',
      required: 'This field is required',
      underLimit: 'The amount entered cannot be lower than €0',
    },
    limitsDescription: '{amount} of {maxAmount}',
    paymentDescription: 'Setting limits',
    paymentFormTitle: 'Payments (over 7 rolling days)',
    paymentLabel: 'Current payment limit',
    paymentLimitUpdated: 'The new payment limit has been saved!',
    paymentTitle: 'Change payment limit',
  },
  fr: {
    atmDescription:
      'Le plafond de retrait concerne tous les distributeurs automatiques',
    atmFormTitle: 'Retrait (30\xa0jours glissants)',
    atmLabel: 'Plafond de retrait actuel',
    atmLimitUpdated: 'Le nouveau plafond de retrait a bien été enregistré\xa0!',
    atmTitle: 'Modifier le plafond de retrait',
    cta: 'Enregistrer',
    errorMessage: 'Oups\xa0! Une erreur inconnue est survenue.',
    errors: {
      overLimit: 'Le montant renseigné ne peut-être supérieur à {limit}\xa0€',
      required: 'Ce champ est requis',
      underLimit: 'Le montant renseigné ne peut-être inférieur à 0\xa0€',
    },
    limitsDescription: '{amount} sur {maxAmount}',
    paymentDescription: 'Réglages du plafond',
    paymentFormTitle: 'Paiement (7\xa0jours glissants)',
    paymentLabel: 'Plafond de paiement actuel',
    paymentLimitUpdated:
      'Le nouveau plafond de paiement a bien été enregistré\xa0!',
    paymentTitle: 'Modifier le plafond de paiement',
  },
} as const);

export default locales;
